// Arcane Illumina — Theme System
// Two themes: dark (default) and light

export const THEMES = {
  dark: {
    bg: "#060812",
    surface: "#0d1526",
    surfaceHover: "#142040",
    text: "#f0f2fc",
    textMuted: "#8892b0",
    accent: "#f0c040", // Illumina gold
    accentSoft: "rgba(240, 192, 64, 0.12)",
    accent2: "#8b5cf6", // Arcane violet
    accent2Soft: "rgba(139, 92, 246, 0.12)",
    accent3: "#67e8f9", // Electric cyan (tertiary)
    border: "rgba(240, 192, 64, 0.14)",
    navBg: "rgba(6, 8, 18, 0.85)",
    sectionOverlay: "rgba(6, 8, 18, 0.6)",
    shadow: "0 4px 32px rgba(0, 0, 0, 0.6)",
    glowGold: "0 0 20px rgba(240, 192, 64, 0.3)",
    glowViolet: "0 0 20px rgba(139, 92, 246, 0.3)",
  },
  light: {
    bg: "#f5f3ee", // aged parchment
    surface: "#ffffff",
    surfaceHover: "#f0ede6",
    text: "#1a1a2e",
    textMuted: "#5c6078",
    accent: "#b45309", // dark amber
    accentSoft: "rgba(180, 83, 9, 0.1)",
    accent2: "#7c3aed",
    accent2Soft: "rgba(124, 58, 237, 0.1)",
    accent3: "#0891b2",
    border: "rgba(180, 83, 9, 0.15)",
    navBg: "rgba(245, 243, 238, 0.88)",
    sectionOverlay: "rgba(245, 243, 238, 0.7)",
    shadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
    glowGold: "0 0 16px rgba(180, 83, 9, 0.2)",
    glowViolet: "0 0 16px rgba(124, 58, 237, 0.2)",
  },
};

import { createContext, useContext } from "react";

export const ThemeContext = createContext({
  isDark: true,
  setIsDark: () => {},
  theme: THEMES.dark,
});

export const useTheme = () => useContext(ThemeContext);
